module.exports = __webpack_public_path__ + "img/neteller.d856097f.svg";